import React, { useState, useRef, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
// import Button from "../../../components/Button";
// import ContactForm from "./contactForms";
import Image from 'next/image';
import dynamic from 'next/dynamic';
import { useRouter } from "next/router";
import { FormProvider } from '@/component/shared/contactForm/formContext';
const ContactFormStep1 = dynamic(() => import('@/component/shared/contactForm/contactFormStep1'), {
  loading: () => <p>Loading...</p>})
const ContactFormStep2 = dynamic(() => import('@/component/shared/contactForm/contactFormStep2'), {
    loading: () => <p>Loading...</p>})

// const MexicoForm = dynamic(() => import('@/component/shared/mexicoForm/mexicoForm'), {
//     loading: () => <p>Loading...</p>})
const MexicoForm = dynamic(() => import('@/component/shared/mexicoForm/mexicoForm'), {
  ssr: false,
});
const USForm = dynamic(() => import('@/component/shared/USForm/USForm'), {
  ssr: false,
});


export const FormsPopups=(props)=> {
  const router = useRouter();
  const { locale } = router;
  const t = (locale === 'es-mx') || (locale === 'en-us') || (locale === 'en-in');
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(true);
  const [showNextStep, setShowNextStep]= useState(false)
const showSteps=()=>{
    setShowNextStep(true)
}
const showFirstStep=()=>{
  setShowNextStep(false)
}

  return (
    <Transition.Root show={props.show} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[110]"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed bg-[rgba(0,0,0,0.6)] inset-0 transition" />
        </Transition.Child>
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full w-full max-w-[500px]">
                <div className="bg-white px-4 pt-2 sm:px-3 sm:pb-4">
                <button className="absolute right-1 top-1 cursor-pointer focus:outline-none" onClick={props.onClose} ><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path fill="#000" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z"/></svg></button>
                  <h2 className="text-xl text-brand text-center font-medium leading-8">{props.heading}</h2>
                  <h3 className="text-sm max-w-[400px] mx-auto mt-1 text-secondary text-center font-regular leading-6">{props.subheading}</h3>
                  <div className="flex mt-1 mb-3 items-center flex-wrap">
                    
                    <div className="w-full px-2 sm:w-full">
                   {locale == 'en-in' &&
                    <FormProvider>
                    {!showNextStep ?
                    <ContactFormStep1 showStep1={showSteps} />:
                      <ContactFormStep2 showPrevStep={showFirstStep} formType={props.formType} formHeading= {props.heading}/>
                    }
                    </FormProvider>
                     }
                     {locale == 'es-mx'  && <MexicoForm />}
                     {locale == 'en-us' && <USForm />}
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default FormsPopups;
